module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-18.efc90d08.png";